// MIDAS V3 — `.cc` dev-surface gate (shared)
//
// Relocated from the retired model-compare chip (MODEL_PICKER_SPEC §3/§5):
// the upcoming per-thread model picker (and any other `.cc`-only dev/QA
// affordance) gates its RENDERING on this hostname check.
//
// UX-ONLY gate: the REAL boundary is server-side (the bot's Origin/Referer
// allowlist, fail-closed). Never treat this client hostname check as the
// security boundary.

/** `.cc`-only surface check. UX gate only — server allowlist is the real gate. */
export const isCcDevSurface = (): boolean => {
  try {
    return (
      typeof window !== "undefined" &&
      window.location.hostname === "app.machine-id.cc"
    );
  } catch {
    return false;
  }
};
